<template>
    <template-layout>
        <template slot="header">
            <h1 class="title">Ayuda</h1>
        </template>

        <template slot="content">
            <section class="container">
                <div class="columns">
                    <div class="column is-one-fifth">
                        <aside class="menu">
                            <ul class="menu-list">
                                <li><a @click="onMenuOptionSelected('help-how-to-buy')" :class="{'active': sectionComponent === 'help-how-to-buy'}">¿Como comprar?</a></li>
                                <li><a @click="onMenuOptionSelected('help-delivery-zones')" :class="{'active': sectionComponent === 'help-delivery-zones'}">¿Llegan a mi domicilio?</a></li>
                                <!-- <li><a @click="onMenuOptionSelected('help-delivery-availability')" :class="{'active': sectionComponent === 'help-delivery-availability'}">Consultar disponibilidad de envios</a></li> -->
                                <li><a @click="onMenuOptionSelected('help-contact')" :class="{'active': sectionComponent === 'help-contact'}">¿Como me contacto con Tallo Verde?</a></li>
                            </ul>
                        </aside>
                    </div>

                    <div class="column is-four-fifths">
                        <component :is="sectionComponent" />
                    </div>
                </div>
            </section>
        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../../layout/TemplateLayout';
    import HelpContact from './HelpContact.vue';
    import HelpHowToBuy from './HelpHowToBuy.vue';
    import HelpDeliveryZones from './HelpDeliveryZones.vue';
    // import HelpDeliveryAvailability from './HelpDeliveryAvailability';

    export default {
        name: 'account',

        data() {
            return {
                sectionComponent: 'help-how-to-buy',
            }
        },

        components: {
            TemplateLayout,
            HelpContact,
            HelpHowToBuy,
            HelpDeliveryZones,
            // HelpDeliveryAvailability
        },

        mounted() {
            let section = this.$route.params.section;
            if(section) {
                this.sectionComponent = section;
            }  
        },

        methods: {
            onMenuOptionSelected(option) {
                this.sectionComponent = option;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>